<!-- 搜索 -->
<template>
  <div class="glsx-combi-form">
    <el-form
      :ref="formRef"
      :inline="true"
      :model="formObj"
      :label-width="labelWidth"
      :rules="formRules"
      size="mini"
      class="glsx-combi-form-block"
    >
      <template v-for="(item, index) in formData">
        <el-form-item
          v-if="!item.isHide"
          :key="index"
          :class="{'no-label': !item.label, 'tips': item.tips}"
          :label="item.label ? (item.label + '：') : ''"
          :prop="item.name"
        >
          <slot
            v-if="item.addHtml"
            :name="item.addHtml"
            :scope="item"
          ></slot>
          <el-input
            v-else-if="item.type === 'input'"
            :placeholder="item.placeholder || ('请输入' + item.label)"
            v-model.trim="formObj[item.name]"
            :disabled="item.isDisabled"
            :maxlength="item.maxlength"
            :clearable="item.isClear || false"
            :type="item.inputType || 'text'"
            :style="{ width: item.width || 'auto' }"
            :show-word-limit="item.showLimit || false"
            @keydown.native="e => handleInputDown(e, item)"
          ></el-input>
          <!-- 选择-输入框 -->
          <el-input
            v-else-if="item.type === 'selectInput'"
            :placeholder="'请输入' + item.selectOption.find(k => k.name === searchSelectObj[item.selectName].attr).label"
            v-model.trim="searchSelectObj[item.selectName].value"
            :clearable="item.isClear || false"
            class="input-with-select"
          >
            <el-select
              v-model="searchSelectObj[item.selectName].attr"
              style="width: 130px"
              slot="prepend"
              placeholder="请选择"
              @change="item.handleSelectChange"
            >
              <el-option
                v-for="(subItem, subIndex) in item.selectOption"
                :key="subIndex"
                :label="subItem.label"
                :value="subItem.name"
              ></el-option>
            </el-select>
          </el-input>
          <!-- 选择-时间选择框 -->
          <template v-else-if="item.type === 'selectDatePicker'">
            <el-select
              v-model="searchSelectObj[item.selectName].attr"
              style="width: 130px"
              placeholder="请选择"
              @change="item.handleSelectChange"
            >
              <el-option
                v-for="(subItem, subIndex) in item.selectOption"
                :key="subIndex"
                :label="subItem.label"
                :value="subItem.name"
              ></el-option>
            </el-select>
            <el-date-picker
              v-model="searchSelectObj[item.selectName].value"
              style="width: calc(100% - 130px)"
              :type="item.dateType || 'daterange'"
              :clearable="item.isClear || false"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOption[item.pickerOptions]"
            >
            </el-date-picker>
          </template>
          <!-- 双选择框 -->
          <template v-else-if="item.type === 'selectDouble'">
            <el-select
              v-model="searchSelectObj[item.selectName].attr"
              style="width: 130px"
              placeholder="请选择"
              @change="item.handleSelectChange"
            >
              <el-option
                v-for="(subItem, subIndex) in item.selectOption"
                :key="subIndex"
                :label="subItem.label"
                :value="subItem.name"
              ></el-option>
            </el-select>
            <el-select
              v-model="searchSelectObj[item.selectName].value"
              style="width: calc(100% - 130px)"
              :placeholder="'请选择' + item.selectOption.find(k => k.name === searchSelectObj[item.selectName].attr).label"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <el-option
                v-for="subItem in item.selectOption.find(k => k.name === searchSelectObj[item.selectName].attr).optionList"
                :key="subItem[item.optionId]"
                :label="subItem[item.optionLabel]"
                :value="subItem[item.optionId]"
              ></el-option>
            </el-select>
          </template>
          <!-- 选择框 -->
          <el-select
            v-else-if="item.type === 'select'"
            :style="{ width: item.width || '100%'}"
            v-model="formObj[item.name]"
            :clearable="item.isClear || false"
            :placeholder="'请选择' + item.label"
            :filterable="!item.noFilter"
            :disabled="item.isDisabled"
            :no-data-text="item.noDataText || '无数据'"
            :multiple="item.multiple || false"
            :collapse-tags="item.collapseTags || true"
            @change="selectAddAttr($event, item)"
          >
            <el-option
              v-for="subItem in item.optionList"
              :key="subItem[item.optionId]"
              :label="subItem[item.optionLabel]"
              :value="subItem[item.optionId]"
              :disabled="subItem.isDisabled || false"
            >
            </el-option>
          </el-select>
          <!-- radio -->
          <el-radio-group
            v-else-if="item.type === 'radio'"
            v-model="formObj[item.name]"
            :disabled="item.isDisabled"
            @change="item.handleRadioChange"
          >
            <el-radio
              v-for="subItem in item.optionList"
              :key="subItem[item.optionId]"
              :label="subItem[item.optionId]"
            >{{subItem[item.optionLabel]}}</el-radio>
          </el-radio-group>
          <el-date-picker
            v-else-if="item.type === 'datePicker'"
            v-model="formObj[item.name]"
            :type="item.dateType || 'daterange'"
            :clearable="item.isClear || false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOption[item.pickerOptions]"
          >
          </el-date-picker>
        </el-form-item>
      </template>
      <slot></slot>
    </el-form>
  </div>
</template>

<script>
import { rangePickerOptions } from './common'
export default {
  name: 'glsx-combi-form',
  data() {
    return {
      pickerOption: {
        rangePickerOptions: rangePickerOptions
      }
    }
  },

  props: {
    formRef: {
      type: String,
      default: 'formRef'
    },
    labelWidth: {
      type: String,
      default: '85px'
    },
    formData: {
      type: Array,
      default: () => []
    },
    formObj: {
      type: Object,
      default: () => { }
    },
    hasTitle: {
      type: Boolean,
      default: true
    },
    formRules: {
      type: Object,
      default: () => { }
    },
    // 搜索+输入框/搜索组合组件，搜索栏绑值
    searchSelectObj: {
      type: Object,
      default: () => { }
    }
  },

  mounted() { },

  methods: {
    // 选择框-添加其他属性
    selectAddAttr(value, targetItem) {
      targetItem.changeAttr && targetItem.changeAttr(value, targetItem)
    },
    handleInputDown(e, item) {
      if (e.keyCode === 13 && item.hasOwnProperty('keyFn')) {
        item.keyFn()
      }
    }
  }
}

</script>
<style>
/* .glsx-combi-form {
  min-width: 922px;
} */
.glsx-combi-form .glsx-combi-form-block {
  padding: 16px 40px 0;
}
/* .glsx-combi-form .el-form-item {
  width: 65%;
} */
.glsx-combi-form .no-label.el-form-item--mini .el-form-item__content,
.el-form-item--mini .el-form-item__label {
  width: 100%;
}
/* .glsx-combi-form .el-form-item--mini .el-form-item__content {
  width: calc(100% - 85px);
} */
.glsx-combi-form .el-col {
  margin-bottom: 10px;
}
.glsx-combi-form .el-select {
  width: 100%;
}
.glsx-combi-form .item-height {
  height: 37px;
}

.glsx-combi-form input::-webkit-outer-spin-button,
.glsx-combi-form input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
.glsx-combi-form input[type='number'] {
  -moz-appearance: textfield !important;
}

.glsx-combi-form .input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.glsx-combi-form .tips {
  margin: 0;
}
</style>
